<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title [ngClass]="{'ion-title-icon': idCultoAgenda && isAdmEscala}">
      {{'Detalhes' | translate}} {{'culto' | nomenclatura | async}}
    </ion-title>

    <ion-col class="end-filter" *ngIf="idCultoAgenda && isAdmEscala">
      <div (click)="openEscala()">
        <i class="fa-solid fa-gear"></i>
      </div>
    </ion-col>
  </ion-buttons>
</ion-header>

<ion-content>
  <app-loading-spinner *ngIf="!loaded"></app-loading-spinner>
  <div *ngIf="loaded">
    <div class="gradient-extendido"></div>

    <ion-card class="gradient-extendido-recuo card-img">
      <img [src]="cultoAgenda.agenda.imagem | image:'culto'" />
    </ion-card>

    <ion-grid>
      <ion-row style="text-align: center">
        <ion-col size="12" style="padding: 0 20px">
          <ion-label class="titulos-info">
            <h2>{{!cultoAgenda.agenda.tema ? cultoAgenda.agenda.culto.descricao : cultoAgenda.agenda.tema}}</h2>

            <img
              *ngIf="hasCheckIn || isResponsavelCheckin"
              (click)="leitor()"
               style="color: #000000; float: right; width: 10%;"
              src="assets/icon/qrcode.svg"
            />

            <span>
              {{cultoAgenda.agenda.dataInicio | dateFormat:'mediaHora'}} {{cultoAgenda.agenda.dataFim | dateFormat:'hora'}}
            </span>

            <p>{{cultoAgenda.agenda.culto.eventoTipo.nome }}</p>
          </ion-label>

          <ion-row class="content-row one-line" *ngIf="!hasCheckIn && isResponsavelCheckin">
            <ion-col (click)="habilitarCheck(multiplosCheckin);">
              <ion-item style="padding: 0 0 0 15px">
                <ion-label style="font-size: 12px; margin-left: 15px">
                  {{'Habilitar Leitura Contínua de QR Code ?' | translate}}
                </ion-label>
                <ion-checkbox slot="start" class="style-checkbox" [checked]="multiplosCheckin"></ion-checkbox>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="userProvider.isLider() && userProvider.hasConfig(18) && isInstituicaoAtual" class="border-bottom">
        <ion-col size="8" offset="2">
          <ion-button class="btn-default" expand="block" (click)="selecionarCulto()">
            {{'Lista de Presença' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div class="link border-bottom" *ngIf="cultoAgenda.agenda.links">
      <ion-list class="content-link programacao-list">
        <ion-item class="bold-1" *ngFor="let l of cultoAgenda.agenda.links" (click)="openLink(l)">
          <ion-label class="links-subscribe"> {{l.nome}} </ion-label>

          <ion-note slot="end">
            <i class="fa-solid fa-up-right-from-square"></i>
          </ion-note>
        </ion-item>
      </ion-list>
    </div>

    <div *ngIf="cultoAgenda.agenda.minhaFuncaoCulto?.idFuncao" class="link">
      <div class="gradient-extendido-div">
        <div class="div-top">
          <ion-note slot="start">
            <i class="far fa-address-card div-icon" style="margin-top: 2px"></i>
          </ion-note>

          <ion-label class="color-title"> {{'Sua Função' | translate}} </ion-label>
        </div>
      </div>

      <ion-card style="border-radius: 1rem">
        <ion-card-header class="extendido">
          <ion-card-subtitle>
            <div class="item-description" *ngFor="let culto of cultoAgenda.agenda.minhaFuncaoCulto.pessoaFuncaoEspec">
              <p class="description-text bold-1">
                <span> {{culto.nome}} </span>
              </p>
            </div>
          </ion-card-subtitle>
        </ion-card-header>

        <ion-card-content
          class="subCard"
          *ngIf="cultoAgenda.agenda.minhaFuncaoCulto.presenca == '0' || cultoAgenda.agenda.minhaFuncaoCulto.presenca == null"
        >
          <ion-row class="row-top" (click)="confirmar(cultoAgenda.agenda.minhaFuncaoCulto, '1')">
            <ion-col size="12">
              <p>{{'Confirmar Presença' | translate}}</p>
            </ion-col>
          </ion-row>
        </ion-card-content>

        <ion-card-content class="subCard-c" *ngIf="cultoAgenda.agenda.minhaFuncaoCulto.presenca == '1'">
          <ion-row class="row-top" (click)="confirmar(cultoAgenda.agenda.minhaFuncaoCulto, '0')">
            <ion-col size="12">
              <p>{{'Cancelar Presença' | translate}}</p>
            </ion-col>
          </ion-row>
        </ion-card-content>
      </ion-card>
    </div>

    <ion-grid *ngIf="cultoAgenda.agenda.pessoaPregador && cultoAgenda.agenda.pessoaPregador.id != '0'">
      <div class="gradient-extendido-div">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fa-solid fa-user-tie div-icon"></i>
          </ion-note>

          <ion-label class="color-title" *ngIf="!isCatholic">
            {{'Pregador' | translate}}/{{'Palestrante' | translate}}
          </ion-label>

          <ion-label class="color-title" *ngIf="isCatholic">
            {{'Celebrante' | translate}} / {{'Palestrante' | translate}}
          </ion-label>
        </div>
      </div>

      <ion-row class="border-bottom">
        <ion-col>
          <ion-item class="avatar-square no-border">
            <ion-avatar slot="start">
              <img class="avatar-image" [src]="cultoAgenda.agenda.pessoaPregador.foto | image:' '" />
            </ion-avatar>

            <ion-label class="item-content">
              <h3 class="item-title">
                <span class="bold-2"> {{cultoAgenda.agenda.pessoaPregador.nome}} </span>
              </h3>
            </ion-label>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-card
      style="border-radius: 1rem"
      *ngIf="cultoAgenda.agenda.pauta && (!userProvider.hasConfig(151) || (userProvider.hasConfig(151) && cultoAgenda.agenda.minhaFuncaoCulto))"
    >
      <ion-card-header class="extendido" (click)="copiar()">
        <ion-card-title> {{'Pauta do culto' | translate}} <i class="fa-solid fa-copy"></i> </ion-card-title>

        <ion-card-subtitle>
          <div class="trix-content" [innerHTML]="cultoAgenda.agenda.pauta | safeHtml: 'html'"></div>
        </ion-card-subtitle>
      </ion-card-header>
    </ion-card>

    <ion-grid *ngIf="cultoAgenda.agenda.programacao && cultoAgenda.agenda.programacao.length > 0">
      <div class="gradient-extendido-div">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fa-solid fa-list-ul div-icon"></i>
          </ion-note>

          <ion-label class="color-title"> {{'Programação' | translate}} </ion-label>
        </div>
      </div>

      <ion-row class="border-bottom">
        <ion-col>
          <ion-list class="programacao-list">
            <ion-item
              class="list-item"
              *ngFor="let p of cultoAgenda.agenda.programacao"
              (click)="detalhesProgramacao(p)"
            >
              <ion-label class="item-content">
                <div class="data-item">
                  <div class="item-content">
                    <h2 class="item-title one-line bold-2">{{p.descricao}}</h2>

                    <div class="item-description">
                      <p class="description-text bold-1">{{p.horaInicio}} {{'Até' | translate}} {{p.horaFim}}</p>
                    </div>

                    <div class="item-description">
                      <p class="description-text one-line bold-1">{{p.cultoProgramacaoTipo.descricao }}</p>
                    </div>
                  </div>
                </div>
              </ion-label>

              <ion-note slot="end">
                <i class="fa-solid fa-ellipsis-vertical icon-list"></i>
              </ion-note>
            </ion-item>
          </ion-list>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid
      *ngIf="((userProvider.hasConfig(109)
        || (userProvider.hasConfig(110) && cultoAgenda.agenda.minhaFuncaoCulto || cultoAgenda.agenda.escalaResponsavel.permissao == '1'))  && idCultoAgenda)"
    >
      <div class="gradient-extendido-div" *ngIf="temEncarregados">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fas fa-user-friends div-icon"></i>
          </ion-note>

          <ion-label class="color-title"> {{'Encarregados' | translate}} </ion-label>

          <i
            class="fa-solid fa-circle-check"
            slot="end"
            *ngIf="cultoAgenda.agenda.minhaFuncaoCulto && cultoAgenda.agenda.minhaFuncaoCulto.permissao_presenca == '1'"
            style="float: right; font-size: 1.7rem; color: #20cc0a"
            (click)="encarregados()"
          ></i>
        </div>
      </div>

      <ion-row *ngIf="temEncarregados">
        <ion-searchbar
          show-cancel-button="never"
          class="custom"
          (ionCancel)="onCancel()"
          placeholder="{{'Buscar Encarregado' | translate}}"
          [(ngModel)]="filtro.q"
          (ionInput)="onInput()"
        >
        </ion-searchbar>
      </ion-row>

      <ion-row *ngFor="let encarregado of encarregadoList; let last = last">
        <ion-col (click)="detalhes(encarregado)">
          <ion-item class="avatar-square ion-margin-vertical">
            <ion-avatar slot="start">
              <img class="avatar-image" [src]="encarregado.pessoa.foto | image:''" />
            </ion-avatar>

            <ion-label class="item-content">
              <h3 class="item-title">
                <i
                  *ngIf="encarregado.presenca == '1' && cultoAgenda.agenda.minhaFuncaoCulto "
                  class="check-presenca fa-solid fa-circle-check"
                  name="checkmark-circle"
                >
                </i>
                <span class="bold-2"> {{encarregado.pessoa.nome}} </span>
                <i
                  *ngIf="encarregado.permissaoLeituraQrCode === '1'"
                  class="fas fa-sharp fa-solid fa-scanner-gun"
                  style="font-size: 1rem !important; margin-left: 0.5rem"
                ></i>
              </h3>

              <div class="item-description">
                <p class="description-text">
                  <span style="color: var(--theme-color-segmentText)"> {{encarregado.pessoaFuncoesEspec.funcao}} </span>
                </p>
              </div>
            </ion-label>

            <ion-note slot="end" *ngIf="isAdmEscala">
              <div class="btn-prover-out">
                <i class="icon-list fa-solid fa-ellipsis-vertical" style="font-size: 23px"></i>
              </div>
            </ion-note>
          </ion-item>
          <div *ngIf="!last" class="linha-vertical"></div>
        </ion-col>
      </ion-row>

      <ion-infinite-scroll
        (ionInfinite)="loadEncarregados($event)"
        *ngIf="pagination.currentPage < pagination.pageCount"
      >
        <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-grid>
    <br />
    <br />
  </div>

  <ion-fab
    slot="fixed"
    vertical="bottom"
    horizontal="end"
    *ngIf="idCultoAgenda && !userProvider.hasConfig(156) && !userProvider.isAnonimo() && loaded"
  >
    <ion-fab-button (click)="anotacao()">
      <i class="fa-regular fa-plus"></i>
    </ion-fab-button>
  </ion-fab>
</ion-content>
